import { render, staticRenderFns } from "./editResourceStoreSpecification.vue?vue&type=template&id=33d1d8ba&scoped=true"
import script from "./editResourceStoreSpecification.vue?vue&type=script&lang=js"
export * from "./editResourceStoreSpecification.vue?vue&type=script&lang=js"
import style0 from "./editResourceStoreSpecification.vue?vue&type=style&index=0&id=33d1d8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d1d8ba",
  null
  
)

export default component.exports